module.exports = __webpack_public_path__ + "img/avatar-s-8.d6c23222.jpg";